import type { DeepRequired } from '../fixtures.types'
import clientHealthInfo from './clientHealthInfo.fixture'

const clientVersion: DeepRequired<ClientVersion> = {
  __typename: 'ClientVersion',
  id: 'TEST_ID',
  client_id: 'TEST_ID',
  created_at: null,
  version_created_at: null,
  version: 1,
  details: {
    __typename: 'Client',
    id: 'TEST_ID',
    client_id: 'TEST_ID',
    accounts: [],
    additional_vulnerabilities_details: null,
    addresses: [],
    agreed_budget: null,
    agreed_monthly_protection_budget: null,
    amount_of_savings: null,
    applicants_are_high_tax_rate_payers: null,
    calculated_values: null,
    cases: [],
    client_ext_ids: null,
    client_height: null,
    client_originator: null,
    client_type: null,
    client_weight: null,
    clientUserIdd: null,
    contact_details_email: null,
    contact_details_home_phone: null,
    contact_details_mobile_phone: null,
    contact_details_work_phone: null,
    contact_history: [],
    country_of_birth: null,
    credit_history_adverse_details_has_arrears: null,
    credit_history_adverse_details_has_client_declared_bankruptcy: null,
    credit_history_adverse_details_has_client_had_ccj: null,
    credit_history_adverse_details_has_client_had_debt_management_plan: null,
    credit_history_adverse_details_has_client_had_default: null,
    credit_history_adverse_details_has_client_had_iva: null,
    credit_history_adverse_details_has_client_missed_payments: null,
    credit_history_adverse_details_has_missed_payments_cleared: null,
    credit_history_adverse_details_missed_any_payments_on_commitments_details: null,
    credit_history_adverse_details_number_of_missed_payments: null,
    credit_history_arrears: null,
    credit_history_bankruptcy_events: null,
    credit_history_county_court_judgements: null,
    credit_history_debt_management_plans: null,
    credit_history_default_events: null,
    credit_history_has_ever_surrendered_a_property_or_been_repossessed: null,
    credit_history_has_ever_surrendered_a_property_or_been_repossessed_details: null,
    credit_history_have_you_ever_had_an_application_denied_or_refused: null,
    credit_history_individual_voluntary_arrangements: [],
    credit_idd: null,
    credit_report_retrievals: [],
    date_of_birth: null,
    date_of_name_change: null,
    debts: [],
    dependants: [],
    deposits: [],
    disposable_income: null,
    document_categories: [],
    document_totals: [],
    employment_status: null,
    external: [],
    face_to_face: null,
    first_name: null,
    gender: null,
    has_reviewed_will_in_last_five_years: null,
    has_will: null,
    health_information: clientHealthInfo,
    id_verification_status: null,
    income_and_employment: [],
    is_natural_person: null,
    is_politically_exposed: null,
    is_vulnerable: null,
    last_name: null,
    limited_company_registration_number: null,
    maiden_or_previous_name: null,
    marital_status: null,
    miDocuments: null,
    middle_name: null,
    mortgage_application_refused: [],
    mortgages: [],
    name_change_reason: null,
    national_insurance_number: null,
    nationalities: [],
    net_monthly_income: null,
    non_natural: null,
    non_natural_organisation_type: null,
    organisation_name: null,
    organisation_sic: null,
    outgoings: null,
    outgoings_additional_details: null,
    outgoings_car_costs: null,
    outgoings_change_details: null,
    outgoings_child_care: null,
    outgoings_clothing: null,
    outgoings_communications: null,
    outgoings_council_tax: null,
    outgoings_entertainment: null,
    outgoings_food: null,
    outgoings_fuel: null,
    outgoings_ground_rent_service_charge_shared_equity_rent: null,
    outgoings_holidays: null,
    outgoings_household_repairs: null,
    outgoings_insurance: null,
    outgoings_investments: null,
    outgoings_maintenance_payments: null,
    outgoings_material_change_details: null,
    outgoings_mortgage_rent: null,
    outgoings_other_living_costs: null,
    outgoings_other_transport_costs: null,
    outgoings_pension: null,
    outgoings_sports: null,
    outgoings_television_license: null,
    outgoings_water: null,
    prev_first_name: null,
    prev_surname: null,
    previous_name: null,
    previous_names: [],
    properties: [],
    propertiesCp: [],
    relationships: [],
    relatedClients: [],
    residency_status: null,
    retirement_age: null,
    smoker_status: null,
    title: null,
    total_additional_annual: null,
    total_guaranteed_annual: null,
    unearned_income: [],
    version: null,
    vulnerabilities: [],
    opt_out_credit_refresh: null,
    anticipated_retirement_unearned_income: [],
    anticipated_retirement_income: [],
    display_weight_unit: null,
    display_height_unit: null,
    risk_reports: [],
    vulnerability_details: [],
    vulnerability_assessments: [],
  },
  versions: [],
}

export default clientVersion
